export const billingRulesButtonStyles = theme => ({
  alignSelf: 'unset',
  color: theme.palette.primary.main,
  cursor: 'pointer',
  display: 'flex',
  gridColumn: '2 / 3',
  gridRow: 1,
  justifySelf: 'flex-end',
  textDecoration: 'none',
  width: 158,
  [theme.breakpoints.up('md')]: {
    alignSelf: 'start',
    gridColumn: 'unset',
    gridRow: 'unset',
    justifySelf: 'flex-start',
  },
});

export const buttonBoxContainerStyles = theme => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  bottom: 0,
  boxShadow: theme.shadows[0],
  display: 'flex',
  height: 64,
  justifyContent: 'center',
  position: 'absolute',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    backgroundColor: 'unset',
    boxShadow: 'unset',
    height: 'unset',
    justifyContent: 'flex-end',
    position: 'unset',
  },
});

export const cardContainer = theme => ({
  backgroundColor: theme.palette.surface.light,
  borderRadius: 2,
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('md')]: {
    backgroundColor: theme.palette.surface.white,
    boxShadow: theme.shadows[6],
    padding: theme.spacing(4),
    width: 744,
  },
  width: '100%',
});

export const dropdown = theme => ({
  backgroundColor: 'transparent',
  [theme.breakpoints.up('md')]: {
    backgroundColor: 'unset',
  },
});

export const footerButton = theme => ({
  marginLeft: theme.spacing(3),
  width: 104,
});

export const helperTextStyles = theme => ({
  ...theme.typography.caption,
  color: theme.palette.error.main,
  margin: theme.spacing(1, 2, 0),
});

export const infoIcon = {
  height: 18,
  width: 18,
};

export const menuPaper = theme => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: 230,
  },
});

export const totalDivider = theme => ({
  gridColumn: '1 / 3',
  marginBottom: theme.spacing(2),
  width: '100%',
});

export const totalSection = {
  display: 'grid',
  gridTemplate: '28px 17px 2fr / 1fr 1fr',
};

export const totalTitle = theme => ({
  color: theme.palette.text.primary,
  gridColumn: '1 / 2',
  width: '100%',
});

export const totalsContainer = theme => ({
  gridColumn: '1 / 3',
  [theme.breakpoints.up('md')]: {
    gridColumn: 'unset',
  },
});
